import {Injectable} from '@angular/core';
import {AnnouncementApiService} from './api/announcement-api.service';
import {UrlService} from './url.service';
import {EmptyRowService} from './empty-row.service';
import {ConstantsService} from './constants.service';
import {startWith, tap} from 'rxjs/operators';
import {createInitialNetworkEntity, resolveNetworkEntity} from './helper-functions';
import {Parcel} from '../types/models';

declare const swal: any;
declare const toastr: any;

@Injectable()
export class AnnouncementsService {

    buildingsForRead = [];

    spinnerShow = false;
    showServiceUnavailable = false;
    firstTimeLoading = true;

    defaultTabId = 'announcementsList';

    data: { [key: string]: { get: string, data: any[], total: number } } = {
        [this.defaultTabId]: {
            get: `/v1/service_request?expand=building,suite,resident,createdBy,serviceRequestType,serviceRequestWorkerContract,attachments`,
            data: [],
            total: null
        },
    };

    constructor(
        private announcementsApi: AnnouncementApiService,
        private urlService: UrlService,
        public emptyRowService: EmptyRowService,
    ) {
    }

    getData() {
        this.getDataByQueryParams().subscribe();
    }

    getDataByQueryParams() {
        this.showServiceUnavailable = false;
        this.firstTimeLoading = false;
        this.data[this.defaultTabId].total = null;
        const tabId = this.urlService.queryParams['tab'];
        const queryParams = this.urlService.queryParams;

        return this.announcementsApi.getNoticesList({...queryParams})
            .pipe(
                createInitialNetworkEntity(),
                resolveNetworkEntity(),
                tap(({finished}) => this.spinnerShow = !finished),
                tap(
                    (response) => {
                        this.data[tabId].data = response.entities;
                        this.data[tabId].total = response.total;
                        this.emptyRowService.fillEmptyRow();
                    },
                    () => {
                        this.showServiceUnavailable = true;
                        this.spinnerShow = false;
                    }
                ),
            );
    }

    forceReset() {
        this.data[this.defaultTabId].data = [];
        this.data[this.defaultTabId].total = null;
        this.urlService.resetQueryParams();
    }

    /**
     * Remove notice with confirmation
     */
    removeNotice(noticeId: string) {
        swal(ConstantsService.getSwalConfig('Delete Announcement'),
            () => {
                this.announcementsApi.removeNotice(noticeId).subscribe(() => {
                    toastr.success('Announcement has been deleted.');
                    this.getData();
                });
            }
        );
    }

}



// WEBPACK FOOTER //
// /app/src/app/services/announcements.service.ts